"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mxp_schemas_1 = require("mxp-schemas");
const crypto_1 = require("crypto");
exports.GAQC_AND_EBPAQC_IMPERSONATED_MIN_CPAS = 15000;
exports.GAQC_AND_EBPAQC_NORMAL_USER_MIN_CPAS = 2999;
exports.isCAQType = (membershipType) => membershipType.toLowerCase() === mxp_schemas_1.MembershipTypes.CenterMembershipType.CAQ.toLowerCase();
exports.isCPEAType = (membershipType) => membershipType.toLowerCase() === mxp_schemas_1.MembershipTypes.CenterMembershipType.CPEA.toLowerCase();
exports.isPCPSType = (membershipType) => membershipType.toLowerCase() === mxp_schemas_1.MembershipTypes.CenterMembershipType.PCPS.toLowerCase();
exports.isGAQCType = (membershipType) => membershipType.toLowerCase() === mxp_schemas_1.MembershipTypes.CenterMembershipType.GAQC.toLowerCase();
exports.isEBPAQCType = (membershipType) => membershipType.toLowerCase() === mxp_schemas_1.MembershipTypes.CenterMembershipType.EBPAQC.toLowerCase();
exports.isGAQCorEBPAQCExceedCpa = (membershipType, numberOfCpa, isImpersonated) => (exports.isGAQCType(membershipType.toLowerCase()) || exports.isEBPAQCType(membershipType.toLowerCase())) &&
    ((isImpersonated && Number(numberOfCpa) > exports.GAQC_AND_EBPAQC_IMPERSONATED_MIN_CPAS) ||
        (!isImpersonated && Number(numberOfCpa) > exports.GAQC_AND_EBPAQC_NORMAL_USER_MIN_CPAS));
exports.isOrgGovernmentType = (orgType) => Boolean(orgType === mxp_schemas_1.MembershipTypes.OrganizationType.GOVERNMENT);
exports.isCimaMipProductType = (membershipType) => membershipType.toLowerCase() === mxp_schemas_1.MembershipTypes.CimaMembershipProductSlug.MEMBERSHIP_IN_PRACTICE;
exports.transformFirmMembershipTypeToSlug = (firmMembershipType) => firmMembershipType === mxp_schemas_1.Salesforce.FirmMembershipTypes.CAQ_REGULAR ||
    firmMembershipType === mxp_schemas_1.Salesforce.FirmMembershipTypes.CAQ_ASSOCIATE
    ? mxp_schemas_1.MembershipTypes.CenterMembershipType.CAQ
    : firmMembershipType;
exports.getFirmMembershipTypeForMemberhipSF = (membershipType, isPCAOB = false) => {
    switch (membershipType) {
        case mxp_schemas_1.MembershipTypes.CenterMembershipType.CPEA:
            return mxp_schemas_1.Salesforce.FirmMembershipTypes.CPEA;
        case mxp_schemas_1.MembershipTypes.CenterMembershipType.PCPS:
            return mxp_schemas_1.Salesforce.FirmMembershipTypes.PCPS;
        case mxp_schemas_1.MembershipTypes.CenterMembershipType.GAQC:
            return mxp_schemas_1.Salesforce.FirmMembershipTypes.GAQC;
        case mxp_schemas_1.MembershipTypes.CenterMembershipType.EBPAQC:
            return mxp_schemas_1.Salesforce.FirmMembershipTypes.EBPAQC;
        case mxp_schemas_1.MembershipTypes.CenterMembershipType.CAQ:
            return isPCAOB ? mxp_schemas_1.Salesforce.FirmMembershipTypes.CAQ_REGULAR : mxp_schemas_1.Salesforce.FirmMembershipTypes.CAQ_ASSOCIATE;
        default:
            return '';
    }
};
exports.generateMembershipAccessURL = (appUrl, orderLineItemId) => {
    const token = crypto_1.createHash('md5').update(`${Date.now()}:${orderLineItemId}`).digest('hex').substring(0, 10);
    return `${appUrl}/center-membership/provisioning/${token}`;
};
exports.pcpsInvalidOrgs = (businessType) => [mxp_schemas_1.MembershipTypes.OrganizationType.EDUCATION, mxp_schemas_1.MembershipTypes.OrganizationType.BUSINESS].includes(businessType);
exports.allInvalidOrgs = (businessType) => [mxp_schemas_1.MembershipTypes.OrganizationType.OTHER].includes(businessType);
exports.similarGroupValidOrgs = (organizationType) => [
    mxp_schemas_1.MembershipTypes.CenterMembershipType.GAQC,
    mxp_schemas_1.MembershipTypes.CenterMembershipType.CAQ,
    mxp_schemas_1.MembershipTypes.CenterMembershipType.EBPAQC,
].includes(organizationType);
exports.isCimaPqPathway = (pathway) => pathway === mxp_schemas_1.MembershipTypes.Pathway.PQ;
exports.isChinesePathway = (pathway) => pathway === mxp_schemas_1.MembershipTypes.Pathway.CHINESE_PQ;
exports.isApprenticePathway = (pathway) => pathway === mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L4 || pathway === mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L7;
exports.isFlpPathway = (pathway) => pathway === mxp_schemas_1.MembershipTypes.Pathway.FLP;
exports.isCimaMemBody = (body) => body === mxp_schemas_1.MembershipTypes.MembershipBody.CIMA;
exports.isAicpaMemBody = (body) => body === mxp_schemas_1.MembershipTypes.MembershipBody.AICPA;
exports.isCimaRegularType = (body, membershipType) => {
    return exports.isCimaMemBody(body) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.REGULAR;
};
exports.isCimaPQCandidateProductType = (pathway, membershipType) => {
    return exports.isCimaPqPathway(pathway) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.CANDIDATE;
};
exports.isChinesePQCandidateProductType = (pathway, membershipType) => {
    return exports.isChinesePathway(pathway) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.CANDIDATE;
};
exports.isCimaApprenticeCandidateProductType = (pathway, membershipType) => {
    return exports.isApprenticePathway(pathway) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.CANDIDATE;
};
exports.isCimaAffiliateType = (body, membershipType) => {
    return exports.isCimaMemBody(body) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.AFFILIATE;
};
exports.isAicpaAffiliateType = (body, membershipType) => {
    return exports.isAicpaMemBody(body) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.AFFILIATE;
};
exports.isCimaCandidateType = (body, membershipType) => {
    return exports.isCimaMemBody(body) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.CANDIDATE;
};
exports.isCimaRetiredType = (body, membershipType) => {
    return exports.isCimaMemBody(body) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.RETIRED;
};
exports.isCimaCgmaAffiliateType = (body, membershipType) => {
    return exports.isCimaMemBody(body) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.CGMA_AFFILIATE;
};
exports.isFlpAffiliateType = (pathway, membershipType) => {
    return exports.isFlpPathway(pathway) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.AFFILIATE;
};
exports.isFlpCandidateType = (pathway, membershipType) => {
    return exports.isFlpPathway(pathway) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.CANDIDATE;
};
exports.isFlpRegularType = (pathway, membershipType) => {
    return exports.isFlpPathway(pathway) && membershipType === mxp_schemas_1.MembershipTypes.MembershipKeys.REGULAR;
};
exports.isLapsedAndFlpCurrentPathway = (isLapsed, pathway) => exports.isFlpPathway(pathway) && isLapsed;
//# sourceMappingURL=index.js.map